{
  "level": "subtrain",
  "source": {
    "spawn": "DERIVED_FROM_TREES_BBOX:subtrain",
    "objects": "AREAS.E3:subtrain.e3",
    "mesh": "TREES.E3:subtrain.e3"
  },
  "spawn_point": {
    "position": [
      -3937.5,
      -3310.2857666015625,
      1039.0
    ],
    "facing_rad": 0.0,
    "look_point": [
      -3937.5,
      -3210.2857666015625,
      1039.0
    ],
    "forward": [
      0.0,
      1.0,
      0.0
    ],
    "up": [
      0.0,
      0.0,
      1.0
    ],
    "derived": true
  },
  "mesh_point_cloud": {
    "note": "Raw vertex positions from TREES.E3.",
    "bbox_min": [
      -3937.5,
      -3311.0,
      1015.0
    ],
    "bbox_max": [
      -3937.5,
      -3309.571533203125,
      1015.0
    ],
    "vertex_count": 2,
    "vertices": [
      [
        -3937.5,
        -3311.0,
        1015.0
      ],
      [
        -3937.5,
        -3309.571533203125,
        1015.0
      ]
    ]
  },
  "sectors": [
    {
      "plane_normal": [
        -0.0,
        0.9333444833755493,
        0.3589821457862854
      ],
      "plane_d": 2748.26513671875,
      "bbox_min": [
        -3974.5,
        -3333.0,
        1005.0
      ],
      "bbox_max": [
        -3904.0,
        -3306.0,
        1017.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.8137334585189819,
        -0.5812382102012634
      ],
      "plane_d": 3299.22412109375,
      "bbox_min": [
        -3974.5,
        -3333.0,
        1005.0
      ],
      "bbox_max": [
        -3904.0,
        -3306.0,
        1017.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1005.0,
      "bbox_min": [
        -3974.5,
        -3333.0,
        1005.0
      ],
      "bbox_max": [
        -3904.0,
        -3306.0,
        1017.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1017.0,
      "bbox_min": [
        -3974.5,
        -3333.0,
        1005.0
      ],
      "bbox_max": [
        -3904.0,
        -3306.0,
        1017.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -0.813753604888916,
        -0.5812100172042847
      ],
      "plane_d": -2103.24755859375,
      "bbox_min": [
        -3974.5,
        -3333.0,
        1005.0
      ],
      "bbox_max": [
        -3904.0,
        -3306.0,
        1017.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        0.0,
        0.9079645276069641,
        -0.41904690861701965
      ],
      "plane_d": 3424.968017578125,
      "bbox_min": [
        -3974.5,
        -3333.0,
        1005.0
      ],
      "bbox_max": [
        -3904.0,
        -3306.0,
        1017.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.3378647565841675,
        0.0,
        -0.9411946535110474
      ],
      "plane_d": 2293.4501953125,
      "bbox_min": [
        -3974.5,
        -3333.0,
        1005.0
      ],
      "bbox_max": [
        -3904.0,
        -3306.0,
        1017.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.29125043749809265,
        0.0,
        0.9566468000411987
      ],
      "plane_d": 191.361572265625,
      "bbox_min": [
        -3974.5,
        -3333.0,
        1005.0
      ],
      "bbox_max": [
        -3904.0,
        -3306.0,
        1017.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9333444237709045,
        0.0,
        0.3589821457862854
      ],
      "plane_d": -4006.3486328125,
      "bbox_min": [
        -3937.5,
        -3333.0,
        1005.0
      ],
      "bbox_max": [
        -3904.0,
        -3306.0,
        1017.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.8137334585189819,
        -0.0,
        -0.5812382102012634
      ],
      "plane_d": -2589.764892578125,
      "bbox_min": [
        -3937.5,
        -3333.0,
        1005.0
      ],
      "bbox_max": [
        -3904.0,
        -3306.0,
        1017.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -0.9999999403953552,
        0.0
      ],
      "plane_d": -3310.999755859375,
      "bbox_min": [
        -3937.5,
        -3311.0,
        1005.0
      ],
      "bbox_max": [
        -3919.5,
        -3306.0,
        1017.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": 3919.499755859375,
      "bbox_min": [
        -3937.5,
        -3311.0,
        1005.0
      ],
      "bbox_max": [
        -3919.5,
        -3306.0,
        1017.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1015.0,
      "bbox_min": [
        -3937.5,
        -3311.0,
        1005.0
      ],
      "bbox_max": [
        -3921.5,
        -3306.0,
        1017.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3937.5,
      "bbox_min": [
        -3937.5,
        -3311.0,
        1015.0
      ],
      "bbox_max": [
        -3937.5,
        -3309.571533203125,
        1017.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 3935.5,
      "bbox_min": [
        -3937.5,
        -3311.0,
        1005.0
      ],
      "bbox_max": [
        -3921.5,
        -3306.0,
        1015.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3937.5,
      "bbox_min": [
        -3937.5,
        -3311.0,
        1005.0
      ],
      "bbox_max": [
        -3937.5,
        -3306.0,
        1015.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -3921.5,
      "bbox_min": [
        -3921.5,
        -3311.0,
        1005.0
      ],
      "bbox_max": [
        -3921.5,
        -3306.0,
        1015.0
      ],
      "face_count": 1
    }
  ],
  "placed_objects": [],
  "tutorial_messages": []
}